'use client';

import dayjs from 'dayjs';
import React, { useState } from 'react';

import IconButton from '@mui/material/IconButton';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
  Box,
  Chip,
  Stack,
  Button,
  Select,
  Switch,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  FormControl,
  Autocomplete,
  FormControlLabel,
} from '@mui/material';

import Iconify from '../../../../../components/iconify';
import { useResponsive } from '../../../../../hooks/use-responsive';

type Props = {
  close: () => void;
};

export default function RuleEdit({ close }: Props) {
  const isMobile = useResponsive('down', 'sm');
  const agents = ['Client', 'Merchant', ''];
  const [assigned, setAssigned] = useState(['Client', 'Merchant']);
  const [valueType, setValueType] = useState('');
  const [value, setValue] = useState('');
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [isActive, setIsActive] = useState(false);
  const [agentList, setAgentList] = useState<any>([]);

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 4,
        // boxShadow: 3,
      }}
    >
      <Box sx={{ position: 'absolute', top: 5, right: 5 }}>
        <IconButton onClick={() => close()}>
          <Iconify icon="material-symbols:close-rounded" />
        </IconButton>
      </Box>
      <Stack
        direction={isMobile ? 'column' : 'row'}
        justifyContent="space-between"
        sx={{ cursor: 'pointer' }}
      >
        <Typography variant="h6" gutterBottom mb={2}>
          Rule Edit
        </Typography>
        {/* <Iconify icon="material-symbols:close-rounded" onClick={() => close()} /> */}
      </Stack>
      <Stack gap={1}>
        <Stack direction={isMobile ? 'column' : 'row'} width={1} justifyContent="space-between">
          <Typography gutterBottom>Rule Name</Typography>
          <TextField defaultValue="Rule One" sx={{ width: isMobile ? '100%' : '75%' }} />
        </Stack>
        <Stack direction={isMobile ? 'column' : 'row'} width={1} justifyContent="space-between">
          <Typography gutterBottom>My Percentage</Typography>
          <TextField defaultValue="15%" sx={{ width: isMobile ? '100%' : '75%' }} />
        </Stack>
        <Autocomplete
          multiple
          options={agents}
          value={agentList}
          onChange={(e, newValue) => setAgentList(newValue)}
          renderTags={(v, getTagProps) =>
            v.map((option: any, index: any) => (
              <Chip label={option} color="info" variant="filled" {...getTagProps({ index })} />
            ))
          }
          renderInput={(params) => (
            <TextField {...params} label="Assigned" placeholder="+Customer" />
          )}
        />
      </Stack>

      <Typography gutterBottom>Agent Percentage</Typography>
      <Stack direction={isMobile ? 'column' : 'row'} gap={1}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="value-type-label">Value Type</InputLabel>
          <Select
            labelId="value-type-label"
            value={valueType}
            label="Value Type"
            onChange={(e) => setValueType(e.target.value)}
          >
            <MenuItem value="fixed">Fixed</MenuItem>
            <MenuItem value="percentage">Percentage</MenuItem>
          </Select>
        </FormControl>

        <TextField
          label="Value"
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
          sx={{ mb: 2 }}
        />
      </Stack>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack direction={isMobile ? 'column' : 'row'} gap={1}>
          <DateTimePicker
            label="Start Date"
            value={startDate}
            // onChange={(newValue) => setStartDate(newValue)}
          />
          <DateTimePicker
            label="End Date"
            value={endDate}
            // onChange={(newValue) => setEndDate(newValue)}
          />
        </Stack>
      </LocalizationProvider>

      <FormControlLabel
        control={<Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />}
        label="Active"
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 1 }}>
        <Button sx={{ borderRadius: '20px' }} variant="outlined" onClick={() => close()}>
          Cancel
        </Button>
        <Button sx={{ borderRadius: '20px' }} variant="contained" onClick={() => close()}>
          Save Changes
        </Button>
      </Box>
    </Box>
  );
}
